module.exports = __webpack_public_path__ + "img/icon_calendar.5fef5fe9.svg";